// frontend/src/hooks/useAuth.js
// Custom hook to access AuthContext easily

import { useContext } from 'react';
// ✅ FULLY FIXED: Using named import with curly braces
import { AuthContext } from '../context/AuthContext';

export const useAuth = () => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }

  return context;
};

export default useAuth;